import { BaseProvider } from '@ethersproject/providers'

import { config } from 'configs'
import useERC20 from './useERC20'

export default function usePMT(provider: BaseProvider) {
  return useERC20(provider, config('token.PMT.address'))
}
